/**
 *  @class
 *  @function FreeShipping
 *
 *  Fixed thresholds per currency (set in snippets/free-shipping.liquid).
 *  The threshold is already in the shopper's currency, so there is NO
 *  exchange-rate conversion here. The "spend X more" amount is formatted
 *  in the shopper's active currency.
 */

if (!customElements.get('free-shipping')) {
  const formatRemaining = (cents) => {
    const value = cents / 100;
    const currency =
      (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    const hasFraction = Math.round(value * 100) % 100 !== 0;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: hasFraction ? 2 : 0,
        maximumFractionDigits: 2,
      }).format(value);
    } catch (e) {
      return value.toFixed(hasFraction ? 2 : 0);
    }
  };

  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const amount_text = this.querySelector('.free-shipping--text span');
      const total = parseInt(this.dataset.cartTotal, 10);
      // Threshold is already in the shopper's currency — no conversion.
      const minimum = parseInt(this.dataset.minimum, 10);
      let percentage = 1;
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');

      if (total < minimum) {
        percentage = total / minimum;

        if (amount_text) {
          const remaining = minimum - total;
          amount_text.innerHTML = formatRemaining(remaining);
        }
        this.remainingText.style.display = 'block';
        this.fullText.style.display = 'none';
      } else {
        this.remainingText.style.display = 'none';
        this.fullText.style.display = 'block';
      }

      this.style.setProperty('--percentage', percentage);
    }
  }
  customElements.define('free-shipping', FreeShipping);
}